module.exports = __webpack_public_path__ + "img/widget_v02.889d1ba6.png";